module.exports = __webpack_public_path__ + "img/123.ef9d3448.png";